/**
 * LocationVenueService
 * Service for LocationVenue entity operations
 * Route: api/location-venues
 * Controller: LocationVenuesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * LocationVenueService
 * Handles location venue CRUD operations and custom endpoints
 * Maps to /api/location-venues endpoint
 */
export class LocationVenueService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? LocationVenueService.DEFAULT_SERVICE_PATH,
            basePath: LocationVenueService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get all venues for a specific location
     * GET /api/location-venues/location/{locationId}
     * @param locationId - Location ID
     * @returns Array of location venues
     */
    async getByLocationId(locationId) {
        const response = await this.getByLocationIdRaw(locationId);
        return response.data ?? [];
    }
    /**
     * Get all venues for a specific location (raw)
     * @param locationId - Location ID
     * @returns ResponseData with array of location venues
     */
    getByLocationIdRaw(locationId) {
        const endpoint = this.getEndpoint('byLocationId', `location/${locationId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
LocationVenueService.DEFAULT_SERVICE_PATH = 'locations';
LocationVenueService.BASE_PATH = 'api/location-venues';
//# sourceMappingURL=LocationVenueService.js.map